import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnCamera } from '@lib/api/entities';
import { SnConstantsAPI } from '@lib/api/services';
import { SnCurrentOrganization } from '@lib/auth';

@Component({
  selector: 'sn-camera-schedule-dialog',
  templateUrl: './camera-schedule-dialog.component.html',
  styleUrls: ['./camera-schedule-dialog.component.scss'],
})
export class SnCameraScheduleDialogComponent implements OnInit, OnDestroy {
  public timezone: string;
  public timezoneOptions: string[];
  public existingSchedule: string[];

  private _destroy$ = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SnCamera,
    private readonly _dialogRef: MatDialogRef<SnCameraScheduleDialogComponent>,
    private readonly _currentOrg: SnCurrentOrganization,
    private readonly _constantsAPI: SnConstantsAPI,
  ) {}

  public ngOnInit(): void {
    this.timezone = this.data.aiDetectionTypes[0]?.timezone || this._currentOrg.settings.timezone;
    this._constantsAPI
      .getTimezones()
      .pipe(takeUntil(this._destroy$))
      .subscribe((zones) => {
        this.timezoneOptions = Object.keys(zones);
      });
    this.existingSchedule = this.data.aiDetectionTypes[0].schedules;
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public setSchedules(value: string[]): void {
    this._dialogRef.close({
      schedules: value,
      timezone: this.timezone,
    });
  }

  public cancel(): void {
    this._dialogRef.close();
  }
}
